import { useEffect, useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

export const useTriggerOnFieldChange = (
  watchField: string,
  triggerField: string
) => {
  const { trigger } = useFormContext();
  const [firstRender, setfirstRender] = useState(true);
  const watchValue = useWatch({
    name: watchField,
  });
  useEffect(() => {
    if (firstRender) {
      setfirstRender(false);
    } else {
      trigger(triggerField);
    }
    // Trigger has a big performance penalty so we make
    // sure to only do it when the watch value changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchValue]);
};
